<template>
  <form-toggle
    :button-value="buttonValue"
    :classes="classes"
    :label="label"
    :disabled="isDisabled"
    :is-update-in-process="planetStore.isUpdateInProcess"
    :ignore-update-in-process="ignoreUpdateInProcess"
    :size="size"
    :data-qa="dataQa"
    :toggle-tooltip="toggleTooltip"
    @update:button-value="emit('update:buttonValue', $event)"
  >
  </form-toggle>
</template>

<script setup lang="ts">
import FormToggle from 'ui-component-library/rbz/components/FormToggle.vue';
import { computed } from 'vue';
import { usePlanetStore } from '@/store/PlanetStore';

export type Size = 'big' | 'small';

interface RbzFormToggleProps {
  buttonValue?: boolean;
  classes?: string;
  label?: string;
  disabled?: boolean;
  isUpdateInProcess?: boolean;
  ignoreUpdateInProcess?: boolean;
  size?: Size;
  dataQa?: string;
  toggleTooltip?: string;
}

const planetStore = usePlanetStore();
const props = withDefaults(defineProps<RbzFormToggleProps>(), {
  buttonValue: false,
  classes: '',
  label: '',
  disabled: false,
  size: 'big',
  dataQa: '',
});

interface RbzFormToggleEmits {
  (e: 'update:buttonValue', value: boolean): void;
}

const emit = defineEmits<RbzFormToggleEmits>();

const isDisabled = computed(() => {
  return props.disabled || (planetStore.isUpdateInProcess && !props.ignoreUpdateInProcess);
});
</script>
